import Script from "next/script";
import { META_PIXEL_ID } from "@/lib/analytics";

/**
 * Meta Pixel (PageView). Compartilhado entre o App Router (layout.tsx)
 * e o Pages Router (_app.tsx) para que todas as páginas de campanha sejam medidas.
 *
 * `lazyOnload`: o script da Meta (fbevents.js) é pesado e roda em modo legado
 * (sem otimizações modernas), então carregá-lo no meio da hidratação inflava o
 * Total Blocking Time e disparava os avisos de cookie de terceiro/cache do
 * Lighthouse. Adiando para o tempo ocioso do navegador mantém o PageView sendo
 * medido (poucos segundos depois) sem competir com a pintura inicial da página.
 */
export default function MetaPixel() {
  return (
    <>
      <Script id="meta-pixel" strategy="lazyOnload">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${META_PIXEL_ID}');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
}
